import script from "./PortfolioStatsCards.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioStatsCards.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioStatsCards.vue?vue&type=style&index=0&id=41c890f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c890f6"]])

export default __exports__